import { Component } from "react";
import { Warning, ArrowCounterClockwise, ArrowLeft } from "@phosphor-icons/react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info?.componentStack);
  }

  reset = () => this.setState({ hasError: false, error: null });

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-[60vh] flex items-center justify-center p-6" data-testid="error-boundary">
        <div className="max-w-md w-full border border-border rounded-sm bg-card p-8 text-center">
          <div className="mx-auto h-12 w-12 rounded-full bg-destructive/10 flex items-center justify-center mb-4">
            <Warning size={26} weight="fill" className="text-destructive" />
          </div>
          <h2 className="text-lg font-bold">Something went wrong on this page</h2>
          <p className="text-sm text-muted-foreground mt-2">
            This section hit an unexpected problem — the rest of Neuclius is still running.
            You can retry, or head back to your dashboard.
          </p>
          {this.state.error?.message && (
            <p className="mt-3 text-xs font-mono text-muted-foreground/80 bg-secondary/50 rounded-sm px-3 py-2 break-words" data-testid="error-boundary-detail">
              {String(this.state.error.message).slice(0, 200)}
            </p>
          )}
          <div className="flex items-center justify-center gap-3 mt-6">
            <button
              onClick={this.reset}
              data-testid="error-boundary-retry"
              className="inline-flex items-center gap-1.5 h-9 px-4 rounded-sm bg-primary text-primary-foreground text-sm font-semibold hover:bg-primary/90 transition-colors"
            >
              <ArrowCounterClockwise size={15} weight="bold" /> Try again
            </button>
            <button
              onClick={() => { window.location.href = "/dashboard"; }}
              data-testid="error-boundary-home"
              className="inline-flex items-center gap-1.5 h-9 px-4 rounded-sm border border-border text-sm font-semibold hover:bg-secondary transition-colors"
            >
              <ArrowLeft size={15} weight="bold" /> Back to dashboard
            </button>
          </div>
        </div>
      </div>
    );
  }
}
